// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-menu--horizontal>.el-submenu.is-active .el-submenu__title{border:none!important}.el-avatar{background:#fff!important}.dropdown .el-dropdown-menu__item{width:120px!important;min-width:120px;text-align:center;line-height:40px}", ""]);
// Exports
module.exports = exports;
